import moment from 'moment';
import { useEffect } from 'react';
import { useState } from 'react';

function TimeBar({ timeBarRef: timebar, scrollFunc: scrollIntoview }) {
  const [hrPos, setHrPos] = useState(
    Math.floor(
      moment
        .duration(moment().diff(moment().startOf('day').add(6, 'h')))
        .asMinutes()
    )
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const time = Math.floor(
        moment
          .duration(moment().diff(moment().startOf('day').add(6, 'h')))
          .asMinutes()
      );
      setHrPos(time);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <hr
      ref={timebar}
      style={{
        top: `${hrPos * 5 - 1}px`,
        zIndex: `2`,
        width: '100%',
        position: 'absolute',
        border: '3px solid red',
        marginTop: '-3px',
        transition: 'top 1s',
        opacity: 0.5,
      }}
    />
  );
}

export default TimeBar;
